import { useSyncExternalStore } from 'react';

/**
 * "Chạm vào chip để xem giải thích" is something a teacher only needs to
 * LEARN — so the dashed-underline affordance on the tappable chips (Phép,
 * Hình thức học, Đột xuất) exists only until their popovers have been opened
 * THREE times on this device (any chip counts), then disappears for good.
 *
 * Permanent underline was rejected as long-term ugly; removing it outright
 * was rejected because a user who signs up next month would never learn the
 * chips are tappable; and one single tap was judged too hasty to count as
 * "learned" (Johnny, 2026-08-24) — three taps is the bar. localStorage, not
 * the server: a new device re-showing the nudge until three more taps is
 * harmless (and per-device is the point — it is THIS screen the hand has to
 * learn), and no wire change.
 */
const KEY = 'lophoc.chipHintOpens';
const LEARNED_AT = 3;
const listeners = new Set<() => void>();

function count(): number {
  try {
    return Number(localStorage.getItem(KEY)) || 0;
  } catch {
    // Storage unavailable (private mode) → treat as learned: a permanent
    // underline nobody can ever dismiss is worse than a missing nudge.
    return LEARNED_AT;
  }
}

export function markChipHintLearned() {
  try {
    localStorage.setItem(KEY, String(count() + 1));
  } catch {
    /* nothing to persist to — subscribers still update for this session */
  }
  listeners.forEach((l) => l());
}

export function useChipAffordance(): string {
  const learned = useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => count() >= LEARNED_AT,
    () => true,
  );
  return learned ? '' : 'underline decoration-dashed decoration-current/40 underline-offset-2';
}
